/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaPictureIcon16Light } from './MediaPictureIcon16Light';
import { MediaPictureIcon16Regular } from './MediaPictureIcon16Regular';
import { MediaPictureIcon16Solid } from './MediaPictureIcon16Solid';
import { MediaPictureIcon20Light } from './MediaPictureIcon20Light';
import { MediaPictureIcon20Regular } from './MediaPictureIcon20Regular';
import { MediaPictureIcon20Solid } from './MediaPictureIcon20Solid';
import { MediaPictureIcon24Regular } from './MediaPictureIcon24Regular';
import { MediaPictureIcon24Solid } from './MediaPictureIcon24Solid';
import { MediaPictureIcon32Regular } from './MediaPictureIcon32Regular';
import { MediaPictureIcon64Regular } from './MediaPictureIcon64Regular';
var sizes = {
    16: {
        light: MediaPictureIcon16Light,
        regular: MediaPictureIcon16Regular,
        solid: MediaPictureIcon16Solid,
    },
    20: {
        light: MediaPictureIcon20Light,
        regular: MediaPictureIcon20Regular,
        solid: MediaPictureIcon20Solid,
    },
    24: {
        regular: MediaPictureIcon24Regular,
        solid: MediaPictureIcon24Solid,
    },
    32: {
        regular: MediaPictureIcon32Regular,
    },
    64: {
        regular: MediaPictureIcon64Regular,
    },
};
export var MediaPictureIcon = forwardRef('MediaPictureIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
